import { ViewerEventType, ViewerToggleFullscreenEvent } from '../types/ViewerEvents.type';
const ACTION_BAR_HIDDEN_CLASS = 'av-action-bar-hidden';
export class FullscreenActionBar {
    constructor(config, eventBus, assetViewerView) {
        this.config = config;
        this.eventBus = eventBus;
        this.assetViewerView = assetViewerView;
        this.hideActionBarTimeout = null;
    }
    addEventListeners(iframe = null) {
        this.eventBus.on(ViewerEventType.ViewportChange, this.onViewportChange.bind(this));
        // TODO optimise by debouncing/throttling ? may not be necessary, remove listeners?
        this.container.onmousemove = this.onMouseMove.bind(this);
        this.container.ontouchmove = this.onMouseMove.bind(this);
        if (iframe && iframe.contentWindow) {
            iframe.contentWindow.onmousemove = this.onMouseMove.bind(this);
            iframe.contentWindow.ontouchmove = this.onMouseMove.bind(this);
        }
    }
    render(container, iframe = null) {
        this.actionBar = this.createActionBarFullScreen();
        this.container = container;
        this.container.appendChild(this.actionBar);
        this.addEventListeners(iframe);
        this.show();
    }
    show() {
        clearTimeout(this.hideActionBarTimeout);
        this.actionBar.classList.remove(ACTION_BAR_HIDDEN_CLASS);
        this.setHideTimeout();
    }
    hide() {
        this.actionBar.classList.add(ACTION_BAR_HIDDEN_CLASS);
    }
    focus() {
        this.clearHideTimeout();
        this.actionBar.classList.remove(ACTION_BAR_HIDDEN_CLASS);
    }
    onMouseMove(event) {
        if (this.actionBar.contains(event.target)) {
            return this.focus();
        }
        this.show();
    }
    clearHideTimeout() {
        clearTimeout(this.hideActionBarTimeout);
    }
    setHideTimeout() {
        this.hideActionBarTimeout = setTimeout(() => this.hide(), this.config.ACTION_BAR_HIDE_TIMEOUT);
    }
    onViewportChange() {
        this.show();
    }
    createActionBarFullScreen() {
        const element = (this.actionBar = document.createElement('div'));
        const buttonContainer = document.createElement('div');
        buttonContainer.classList.add('av-action-bar-button-container');
        if (this.assetViewerView.assetViewerItem.isDownloadable) {
            const downloadContainer = (this.downloadContainer = document.createElement('div'));
            downloadContainer.classList.add('av-action-bar-download');
            downloadContainer.innerHTML = `
                <svg  version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="512px"
                    height="512px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><g id="afcae5a789ccd549f9c6e2a2f80cccc2"><path style="display: inline;" d="M400.617,154.126L256,332.976l-144.617-178.85H204.9V0.825h102.2v153.301H400.617z
                        M460.399,154.126v102.2v204.401H51.6V256.326v-102.2l-51.1-51.1v51.1v102.2v255.5h511v-255.5v-102.2v-51.1L460.399,154.126z"></path></g></svg>
                `;
            downloadContainer.onclick = () => this.assetViewerView.download();
            buttonContainer.appendChild(downloadContainer);
        }
        const closeFullscreenContainer = (this.closeFullscreenContainer = document.createElement('div'));
        closeFullscreenContainer.classList.add('av-action-bar-close');
        closeFullscreenContainer.innerHTML = `
            <svg  version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="512px"
                 height="512px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><g id="afcae5a789ccd549f9c6e2a2f80b2306"><path style="display: inline;" d="M339.023,256.022L504.57,427.387L420.104,511.5L256,341.852L91.896,511.5L7.43,427.387
                    l165.549-171.364L7.43,84.884L92.183,0.5L256,170.077L419.818,0.5l84.752,84.384L339.023,256.022z"></path></g></svg>
            `;
        closeFullscreenContainer.onclick = () => this.eventBus.dispatch(new ViewerToggleFullscreenEvent());
        buttonContainer.appendChild(closeFullscreenContainer);
        element.appendChild(buttonContainer);
        element.classList.add('av-action-bar');
        element.classList.add('av-action-bar-small');
        element.classList.add(ACTION_BAR_HIDDEN_CLASS);
        element.classList.add('av-action-bar-top');
        return element;
    }
}
//# sourceMappingURL=FullscreenActionBar.js.map